<template>
  <div>
    <div class="bd-header bd-header_elle">
      <div class="bd-header__menu" @click="shift()">
        <svg height="100" viewBox="-38 -38 100 100" width="100" xmlns="http://www.w3.org/2000/svg" v-if="!isMobile" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M-33-23h90c1.377 0 2.559.488 3.535 1.465S62-19.379 62-18s-.488 2.559-1.465 3.535S58.377-13 57-13h-90c-1.379 0-2.559-.488-3.535-1.465S-38-16.621-38-18s.488-2.559 1.465-3.535S-34.379-23-33-23zm0 60h90c1.377 0 2.559.488 3.535 1.465S62 40.623 62 42s-.488 2.559-1.465 3.535S58.377 47 57 47h-90c-1.379 0-2.559-.488-3.535-1.465S-38 43.377-38 42s.488-2.559 1.465-3.535S-34.379 37-33 37zm0-30h90c1.377 0 2.559.488 3.535 1.465S62 10.621 62 12s-.488 2.559-1.465 3.535S58.377 17 57 17h-90c-1.379 0-2.559-.488-3.535-1.465S-38 13.379-38 12s.488-2.559 1.465-3.535S-34.379 7-33 7z"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123.5 102.7" v-else="" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M47.6 98.1c2.9 2.9 7.7 2.9 10.6 0 2.9-2.9 2.9-7.7 0-10.6L29.4 58.7h83.5c4.1 0 7.5-3.4 7.5-7.5s-3.4-7.5-7.5-7.5H29.4l28.8-28.8c2.9-2.9 2.9-7.7 0-10.6C56.7 2.8 54.8 2 52.9 2s-3.8.7-5.3 2.2L6 45.8c-1.4 1.4-2.2 3.3-2.2 5.3S4.6 55 6 56.4l41.6 41.7z"/></svg>
      </div>
      <div class="bd-header__title bd-ht">
        <img class="bd-ht__img" src="/pages/elle/img/logo.svg" alt="">
      </div>
    </div>
    <div class="bd-feed bd-feed_elle">
      <div class="bd-elle">
        <div class="bd-elle-menu">
          <span class="bd-elle-menu__item">МОДА</span>
          <span class="bd-elle-menu__item bd-elle-menu__pink-text">КРАСОТА</span>
          <span class="bd-elle-menu__item">ЗВЕЗДЫ</span>
          <span class="bd-elle-menu__item">ОТНОШЕНИЯ</span>
          <span class="bd-elle-menu__item">СТИЛЬ ЖИЗНИ</span>
          <span class="bd-elle-menu__item">ГОРОСКОПЫ</span>
          <span class="bd-elle-menu__item">ВИДЕО</span>
        </div>
        <div class="bd-elle-top">
          <h1>Огонь на себя: все, что надо знать о красном</h1>
          <p class="bd-elle-title-text-small">На что способен цвет любви, <br> страсти и удачи</p>
        </div>
        <p class="bd-elle-text">Счастливая способность распознавать
          цвета вдохновляет человечество придумывать новые, умножая
          палитру опознаваемых оттенков. Это удобно не только для
          порядка и разнообразия, но и для упрощения ассоциаций,
          возникающих при упоминании конкретного тона. Базовые цвета
          апеллируют к базовым инстинктам: зеленый — покой и
          безопасность, желтый — тепло и позитив, голубой — чистота
          и безоблачность, в небе и мыслях. Что же приходит на
          ум, когда мы представляем красный? Страсть, вызов,
          предупреждение, жар, провокация, энергия, секс — все
          сразу и по отдельности тоже.</p>
        <div style="margin: 20px">
          <buzzCode @ready="ready" :id="id"></buzzCode>
        </div>

        <p class="bd-elle-text">Красное платье, помада и алые туфли
          на шпильках вдохновляют и мужчин, созерцающих столь
          волнительную картину, и женщину, решившуюся на смелый
          аутфит. Исследования подтверждают, что этот цвет обладает
          суперсилой, действуя на подсознательном уровне, а его
          «носительница» воспринимается как особо привлекательная
          и уверенная в себе. Красный — беспроигрышный выбор для важного
          свидания: его чувственность и драматичность лишают сомнений
          в собственной неотразимости.</p>
        <p class="bd-elle-text">Что еще стоит знать о красном?</p>
        <img src="/pages/elle/img/1.jpeg" alt="">
        <h2>КРАСНЫЙ: МНЕНИЕ АСТРОЛОГОВ</h2>
        <p class="bd-elle-text">Цвет — инструмент невербального
          общения, и красному соответствует широкий диапазон ярких
          эмоций — от гнева и опасности до решимости и страсти.
          В разных культурах этот цвет связан с энергетической
          мощью, сексуальностью и бессмертием. В азиатских
          странах — Китае, Японии, Таиланде, Индии — красный
          с древнейших времен символизирует исключительно
          позитивные проявления: удачу, счастье, восходящее
          солнце, новую жизнь, победу над злом.</p>
        <p class="bd-elle-text">В Европе и Новом Свете красный
          также ассоциируется с энергией, страстью и действием.
          Он как будто распространяет тепло, пробуждая физические
          потребности и волю к выживанию, повышая частоту дыхания,
          сердечных сокращений, кровяное давление, активность
          метаболизма и уровень адреналина в организме. Обобщая,
          можно сказать, что красный усиливает деятельные вибрации
          и желания — как внутри, так и в окружающем пространстве.</p>
        <img src="/pages/elle/img/2.jpeg" alt="">
        <p class="bd-elle-text">Астрологи считают, что каждому
          из нас сопутствует конкретный цвет, отражающий состояние
          тела-ума-души и управляемый определенным небесным телом.
          Красный связан с Марсом, влиятельной планетой, способной
          воодушевлять на действия и сильные эмоции, внушать новаторский дух,
          лидерские качества, потребность доводить дело до конца,
          независимость, уверенность в себе и решимость, необходимую
          для осуществления планов. С другой стороны, агрессивность
          Марса порождает соперничество, разногласия и конфликты,
          побуждая ставить личные амбиции превыше чужих благ.</p>
        <p class="bd-elle-text">Красная планета выступает
          покровителем двух знаков Зодиака — Овна и Скорпиона, но
          именно в рожденных под созвездием Овна боевые и чувственные
          качества Марса раскрываются во всей красе и полноте.</p>
        <img src="/pages/elle/img/3.jpeg" alt="">
        <h2>КРАСНЫЙ: МНЕНИЕ ПСИХОЛОГОВ</h2>
        <p class="bd-elle-text">Говоря о цветовых ассоциациях,
          психологи настаивают, что в дополнение к стереотипам
          восприятия людям свойственно уникальное толкование цветов.
          Тем не менее, большинству очевидно, что красный буквально
          создан для того, чтобы привлекать внимание.</p>
        <p class="bd-elle-text">Как уже упоминалось, этот цвет
          внушает внутреннюю силу и самоуверенность, попутно повышая
          уровень тестостерона и информируя о вашей неотразимости
          того, кто на вас смотрит. Известно, что официантки в
          красном получают чаевые выше, чем те, кто носит форму
          другого цвета, а спортсмены в красной экипировке имеют
          больше шансов на победу, чем те, кто выбрал синий комплект.</p>
        <img src="/pages/elle/img/4.jpeg" alt="">
        <p class="bd-elle-text">Учитывая, что красный привлекает
          внимание, легко понять, почему он часто используется
          в предупреждающих знаках и рекламных объявлениях.
          Собираясь на свидание, однако, стоит учесть, что
          обилие этого цвета провоцирует стрессовую реакцию
          «бей или беги» (fight-or-flight), и потому перебор с красным
          спугнет робких поклонников.</p>
        <p class="bd-elle-text">Один из главных цветов видимого
          спектра бурно «делится» на разные оттенки — от
          нежно-розового до темно-винного, причем коннотации каждого
          варианта тоже тяготеют к разнообразию. Глубокие цвета,
          такие как бордовый или гранатовый, эмоционально окрашивают
          сдержанные, утонченные, но доминантные проявления, а яркие
          оттенки вроде пурпурного или алого подразумевают
          независимую энергию и безудержную страсть.</p>
        <img src="/pages/elle/img/5.jpeg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import buzzCode from '@/components/buzzCode.vue';
import { isMobile } from 'mobile-device-detect';

export default {
  name: 'elle',
  data() {
    return {
      isMobile,
    };
  },
  props: {
    id: {
      type: String,
    },
  },
  components: {
    buzzCode,
  },
  methods: {
    ready() {
      this.$emit('ready');
    },
    shift() {
      if (isMobile) {
        this.$emit('shift');
      }
    },
  },
};
</script>

<style scoped lang='stylus'>

img
  display block
  width 100%
  height auto

.bd
  &-header
    transition margin .4s
    display flex
    flex-flow row nowrap
    position fixed
    z-index 99997
    align-items center
    align-content space-around
    width 100%
    height 60px
    &_hide
      margin-top -60px
    &__menu
      width 30px
      height 20px
      margin 15px
      svg
        width 100%
        height 100%
        display block
    &__title
      width 100%
      text-align center
  &-feed
    box-sizing border-box
    width 100%
    height 100%
    min-height 100%
    padding-top 60px
  &-header
    &_elle
      background white
      border-bottom #d4d4d4 solid 1px
      & ^[1]__menu
        flex-shrink 0
      & ^[1]__title
        margin-right 60px
      & ^[0]-ht__img
        display block
        height 45px
    &__menu
      -webkit-tap-highlight-color transparent
      outline none
  &-svg-icon
    -webkit-tap-highlight-color transparent
    outline none
  &-feed_elle
    padding-top 60px
  &-elle
    margin-top 20px
    &-text
      margin-left 20px
      margin-bottom 20px
      margin-right 20px
      font 18px/26px pt_serifregular,Georgia,serif
      color #000
      text-align left
    &-bottom-block
      font-family Impact, fantasy, sans-serif
      word-spacing 11px
      margin-left 20px
      margin-right 20px
      text-align center
    &-menu
      position relative
      padding 10px 0
      margin 0 20px
      white-space nowrap
      font 16px 'FuturaPTBold',Arial,Helvetica,sans-serif
      line-height 16px
      font-weight bold
      color #000
      overflow hidden
      &__item
        padding 0 8px
        &:nth-child(1)
          margin-left -10px
        &:nth-child(2)
          color #feb9a9
      &:before
        content ''
        position absolute
        background-image url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAABCAYAAADJsB7sAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADNJREFUeNpi/A8EDAwMv4H4FxD/hOIfQPwdiL8h4a9Y8BcsYsh6vkPNgpn7C2oXA0CAAQASzR7/tjbkSwAAAABJRU5ErkJggg==")
        width 30px
        height 20px
        left 0
        top 7px
        z-index 1
      &:after
        content ''
        position absolute
        background-image url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAABCAYAAADJsB7sAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADFJREFUeNpi/P//PwMUsAIxGxCzQzEHEHMCMRcS5kbDPFjEuNH0cELNgpkLsoMVIMAAm2cD/kMpVCEAAAAASUVORK5CYII=")
        width 30px
        height 20px
        right 0
        top 7px
        z-index 1
    &-top
      margin 0 20px
    &-title
      text-align center
    &-bottom
      margin-top 20px
      width 100%
      padding 17px 0
      border-radius 0
      border none
      display block
      background-color #feb9a9
      color #fff
      font 26px Impact, fantasy
      line-height 26px
    &-title-text-small
      font 19px/23px Georgia,serif
      text-align center
      border-bottom #d4d4d4 solid 1px
      padding-bottom 20px
    & img
      display block
      width 100%
    & h1
      font 27px/30px Georgia,serif
      text-align center
    & h2
      margin 20px
      font 25px/28px Georgia,serif
    &-footer
      background #1a1a1a
      padding 20px 10px 50px 10px
      &__copy
        text-align center
        color #747474
        font-size 10px
        padding-bottom 20px
      & img
        width 252px
        margin auto
        display block

</style>
